var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationsMinus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29648 10.0056C4.29648 10.4076 4.60916 10.7203 5.01117 10.7203C5.39085 10.7203 5.72586 10.4076 5.72586 10.0056H6.44054C6.44054 10.8097 5.79286 11.435 5.01117 11.435C4.20714 11.435 3.58179 10.8097 3.58179 10.0056H4.29648Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2246 4.75787C2.9312 4.75787 2.69335 4.99572 2.69335 5.28912C2.69335 5.58252 2.9312 5.82037 3.2246 5.82037H6.79804C7.09145 5.82037 7.32929 5.58252 7.32929 5.28912C7.32929 4.99572 7.09145 4.75787 6.79804 4.75787H3.2246Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58461 4.15413C8.58461 6.27586 9.05362 6.90121 9.67898 7.48189C9.99165 7.79457 10.081 8.24125 9.92465 8.64326C9.76831 9.04527 9.3663 9.29095 8.94195 9.29095H1.08038C0.633702 9.29095 0.231689 9.04527 0.0753514 8.64326C-0.0809867 8.24125 0.00834939 7.79457 0.321025 7.48189C0.946378 6.90121 1.41539 6.27586 1.41539 4.15413C1.41539 2.38974 2.84477 0.938028 4.65382 0.759356V0.357344C4.65382 0.178672 4.81016 0 5.01117 0C5.18984 0 5.36851 0.178672 5.36851 0.357344V0.759356C7.15523 0.938028 8.58461 2.38974 8.58461 4.15413ZM1.08038 8.57626H8.94195C9.25463 8.57626 9.41097 8.21892 9.18763 7.99558C8.40594 7.25855 7.86992 6.43219 7.86992 4.15413C7.86992 2.65775 6.57455 1.42938 5.01117 1.42938C3.42545 1.42938 2.13008 2.65775 2.13008 4.15413C2.13008 6.43219 1.59406 7.25855 0.812374 7.99558C0.589034 8.21892 0.745372 8.57626 1.08038 8.57626Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsMinus);
export default __webpack_public_path__ + "static/media/notifications-minus.1f863680f6523eda888f1ba5f1fbb8b9.svg";
export { ForwardRef as ReactComponent };